import { BaseService } from './base-service';
import { lastValueFrom } from 'rxjs';
export class UserTimersService {
    // ----------------------------------------------------------------------
    // UserTimers
    // ----------------------------------------------------------------------
    static getUserTimerList() {
        return lastValueFrom(BaseService.get(`user-timer-list`));
    }
    static fetchUserTimerStatus(oid) {
        return lastValueFrom(BaseService.get(`user-timer-status/${oid}`));
    }
    static createUserTimer(dto) {
        return lastValueFrom(BaseService.post(`user-timer-create`, dto));
    }
    static updateUserTimer(dto) {
        return lastValueFrom(BaseService.post(`user-timer-update`, dto));
    }
    static playUserTimer(oid) {
        return lastValueFrom(BaseService.post(`user-timer-play/${oid}`, {}));
    }
    static pauseUserTimer(oid) {
        return lastValueFrom(BaseService.post(`user-timer-pause/${oid}`, {}));
    }
    static stopUserTimer(oid) {
        return lastValueFrom(BaseService.post(`user-timer-stop/${oid}`, {}));
    }
    static deleteUserTimer(oid) {
        return lastValueFrom(BaseService.post(`user-timer-delete/${oid}`, {}));
    }
    static createActivity(oid, activity) {
        return lastValueFrom(BaseService.post(`user-timer-create-activity/${oid}`, activity));
    }
}
